export default "__VITE_ASSET__BMNpbGWl__"